module.exports = "<div class=\"modal-body\">\n  {{message}}\n</div>"